import React from 'react';
import classes from './locations.module.css';
import Title from "../../containers/title/title";
import { NavLink } from 'react-router-dom';
import { getImageUrl } from '../../../utils/imageUrl';

const Locations = ({ locations }) => {
    const getTranslatedText = (text) => {
        return parseInt(localStorage.getItem('language')) === 1 
            ? "View on google map" 
            : "عرض على خرائط جوجل";
    };
    
    return (
        <div className={classes.Container}>
            <Title title={locations?.title} />
            <div className={classes.Locations}>
                {locations?.branches?.map((location, i) => <div key={i} className={classes.Location}>
                    <h4>{location.name}</h4>
                    <NavLink to={location.map_link}>{getTranslatedText()}</NavLink>
                    <img src={getImageUrl(location.image_url)} alt={location.name} />
                </div>)}
            </div>
            <div className={classes.MobileLocations} />
        </div>
    )
}
export default Locations;